// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@steiner/MobiusOverrides/TextField";
import React, { FC } from "react";

export interface CustomerPartNumberProps {
    isEditing?: boolean;
    customerPartNumber?: string;
    textFieldProps?: TextFieldProps;
    extendedStyles?: CustomerPartNumberFieldStyles;
}

export interface CustomerPartNumberFieldStyles {
    textField?: TextFieldPresentationProps;
    text?: InjectableCss;
}

export const customerPartNumberFieldStyles: CustomerPartNumberFieldStyles = {};

const CustomerPartNumberField: FC<CustomerPartNumberProps> = React.memo(
    ({ isEditing, customerPartNumber, extendedStyles, textFieldProps }) => {
        const [styles] = React.useState(() => mergeToNew(customerPartNumberFieldStyles, extendedStyles));

        return isEditing ? (
            <TextField {...textFieldProps} {...styles.textField} type="customerPartNumber" />
        ) : (
            <Typography {...styles.text}>{customerPartNumber}</Typography>
        );
    },
);

export default CustomerPartNumberField;
